module.exports = __webpack_public_path__ + "assets/images/app-switcher.275cdbf491d3c6a7f4c3bf450429a762.svg";